import type { CustomInnerHeaderProps } from '@mint-lib/ag-grid/react';

import { TruncateText } from '@mint-lib/tw-components';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

export const TruncatedColumnHeader = ({
  displayName,
}: CustomInnerHeaderProps<MediaPlan.MediaData>) => (
  <TruncateText>
    <span className="block min-w-0 truncate">{displayName}</span>
  </TruncateText>
);
